import { Collapsible, ICollapsibleProps } from '../UI/Collapsible/Collapsible';
import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { styled } from '@mui/material/styles';
import { Form, IFormProps } from './Form';

type ICollapsibleFormProps = Omit<ICollapsibleProps, 'children' | 'header'> & {
	title: string;
	formProps: IFormProps;
	toggable?: boolean;
	onToggle?: (isOpen: boolean) => void;
};
export const CollapsibleForm = styled(
	({
		isOpen: _isOpen,
		softHide = true,
		className,
		title,
		toggable = true,
		formProps,
		...props
	}: ICollapsibleFormProps) => {
		const [isOpen, setOpen] = useState(!toggable || _isOpen);

		const toggle = useMemo(
			() => (toggable ? () => setOpen(!isOpen) : undefined),
			[isOpen, toggable],
		);

		return (
			<Collapsible
				className={classNames('collapsible--form', className)}
				toggle={toggle}
				isOpen={isOpen}
				softHide={softHide}
				header={<span>{title}</span>}
				{...props}
			>
				<Form {...formProps} />
			</Collapsible>
		);
	},
	{ target: 'CollapsibleForm-root', label: 'CollapsibleForm' },
)({
	'& .form': {
		'&> :first-child': {
			marginTop: 0,
		},
		'& .form__row': {
			fontSize: '0.8125em',
			paddingLeft: '1em',
			paddingRight: '1em',
			boxSizing: 'border-box',
		},
	},
});
